(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9233],{

/***/ 70772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/find",
      function () {
        return __webpack_require__(25257);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23978);
/* harmony import */ var _src_api_sign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28702);
/* harmony import */ var _src_component_LeftBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19572);
/* harmony import */ var _src_component_SignButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13097);
/* harmony import */ var _src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34489);
/* harmony import */ var _src_hook_useLoader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26076);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51413);
/* harmony import */ var _src_utils_sign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57386);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4480);














var FindPassword = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), isSend = ref1[0], setIsSend = ref1[1];
    var _type = props.type, type = _type === void 0 ? "client" : _type;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var withLoader = (0,_src_hook_useLoader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_9__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_6__/* .globalSnackbarState */ .j8);
    var signInText = "전문가 비밀번호 재설정";
    if (type === "client") {
        signInText = "고객사 비밀번호 재설정";
    }
    var onClickPasswordFind = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var result, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!email || !(0,_src_utils_sign__WEBPACK_IMPORTED_MODULE_12__/* .validateEmail */ .oH)(email)) {
                            setSnackbareState("이메일 형식이 맞지 않습니다.");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            withLoader((0,_src_api_sign__WEBPACK_IMPORTED_MODULE_1__/* .sendFindPasswordMail */ .c1)(email))
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.id) {
                            setIsSend(true);
                        } else {
                            setSnackbareState("메일 보내기 실패");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setSnackbareState(error.errorMessage || error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickPasswordFind() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .BackGround */ .gJ, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .Ar, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_LeftBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    type: type
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .Content */ .VY, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            !isSend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "title",
                                        children: signInText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 5
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "description1",
                                        children: "가입하신 이메일을 입력해주세요"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 16
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        label: "이메일",
                                        fullWidth: true,
                                        value: email,
                                        placeholder: "hello@1point.kr",
                                        onChange: function(e) {
                                            return setEmail(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 16
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        text: "비밀번호 재설정하기",
                                        onClick: onClickPasswordFind
                                    })
                                ]
                            }),
                            isSend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 10
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "title",
                                        children: "이메일을 보냈습니다"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 35
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "description2",
                                        children: "".concat(email, "로\n보낸 이메일을 확인해주세요")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 16
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        text: "로그인하기",
                                        onClick: function() {
                                            router.replace(type === "client" ? "/" : "/expert");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_4__/* .EmptySpace */ .zV, {
                                        space: 30
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
FindPassword.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(ctx) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            _tmp = {};
            // if (ctx.query.a === "1") throw new Error();
            // console.log(ctx);
            // return { a: ctx.query.a };
            return [
                2,
                ((_tmp.type = ctx.query.type || "client", _tmp))
            ];
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (FindPassword);


/***/ }),

/***/ 28702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ changePassword; },
/* harmony export */   "Ds": function() { return /* binding */ signupWithCompanyInfo; },
/* harmony export */   "IT": function() { return /* binding */ registerWithLogin; },
/* harmony export */   "IU": function() { return /* binding */ signup; },
/* harmony export */   "KJ": function() { return /* binding */ signupCompanyUser; },
/* harmony export */   "Uv": function() { return /* binding */ signupV2; },
/* harmony export */   "Vq": function() { return /* binding */ sendGetIds; },
/* harmony export */   "_J": function() { return /* binding */ sendCert; },
/* harmony export */   "c1": function() { return /* binding */ sendFindPasswordMail; },
/* harmony export */   "ot": function() { return /* binding */ subscribeStibee; },
/* harmony export */   "vB": function() { return /* binding */ confirmCert; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "y0": function() { return /* binding */ signupCompanyUserV2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53249);




var login = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userId, password, userType) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/login", (_tmp.userId = userId, _tmp.password = password, _tmp.userType = userType, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function login(userId, password, userType) {
        return _ref.apply(this, arguments);
    };
}();
var registerWithLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userId, password, key) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/loginWithRegister", (_tmp.userId = userId, _tmp.password = password, _tmp.key = key, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function registerWithLogin(userId, password, key) {
        return _ref.apply(this, arguments);
    };
}();
var subscribeStibee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/utils/stibee/subscribe", data)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function subscribeStibee(data) {
        return _ref.apply(this, arguments);
    };
}();
var sendFindPasswordMail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(email) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/email/password", (_tmp.email = email, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendFindPasswordMail(email) {
        return _ref.apply(this, arguments);
    };
}();
var signup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signup(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupCompanyUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/company-user", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupCompanyUser(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupCompanyUserV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/company-user/v2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupCompanyUserV2(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/v2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupV2(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupWithCompanyInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupWithCompanyInfo(userData) {
        return _ref.apply(this, arguments);
    };
}();
var sendCert = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(authData, type) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/".concat(type), (_tmp.authData = authData, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendCert(authData, type) {
        return _ref.apply(this, arguments);
    };
}();
var sendGetIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(certId, type) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.get */ .sl.get("/auth/ids?certId=".concat(certId, "&type=").concat(type))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendGetIds(certId, type) {
        return _ref.apply(this, arguments);
    };
}();
var confirmCert = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, authNumber) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/cert", (_tmp.id = id, _tmp.authNumber = authNumber, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function confirmCert(id, authNumber) {
        return _ref.apply(this, arguments);
    };
}();
var changePassword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, authNumber, password) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/password/change", (_tmp.id = id, _tmp.authNumber = authNumber, _tmp.password = password, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function changePassword(id, authNumber, password) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 19572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1 0 40vw;\n	position: relative;\n	height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	left: 2.7vw;\n	top: 40%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-style: normal;\n	font-weight: 800;\n	font-size: 2.5vw;\n	line-height: 2.5vw;\n	color: white;\n	width: 35vw;\n\n	* {\n		word-break: break-all;\n		white-space: pre-wrap;\n	}\n\n	> div {\n		padding-top: 5px;\n	}\n\n	/* \bGradient */\n\n	> .color {\n		background: var(--primary);\n		-webkit-background-clip: text;\n		-webkit-text-fill-color: transparent;\n		background-clip: text;\n		text-fill-color: transparent;\n	}\n\n	> .smallText {\n		padding-top: 1vw;\n		font-size: 1.3vw;\n		font-weight: 400;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	left: 0px;\n	top: 0px;\n	width: 150px;\n	padding: 20px;\n	padding-top: 35px;\n	padding-bottom: 35px;\n\n	@media screen and (min-width: 720px) {\n		width: 200px;\n		padding: 10px;\n		padding-top: 25px;\n		padding-bottom: 25px;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LeftBox = function(props) {
    var type = props.type;
    var signUpText = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: "전문가님의 역량으로"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: "초기 스타트업을 돕고 "
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "color",
                children: "부수입을 창출하세요"
            })
        ]
    });
    if (type === "client") {
        signUpText = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "color",
                    children: "상위 10% 마케터를"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: "필요한 만큼 고용하세요"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LeftDescription, {
        className: "pc",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: type === "client" ? "/" : "/expert",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoItem, {
                    className: "btnc",
                    src: "/onepoint/assets/images/logo/h-logo.png",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DescriptionBox, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Description, {
                    children: [
                        signUpText,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "smallText",
                            children: "탑티어 마케터 파트타임 고용 서비스"
                        })
                    ]
                })
            })
        ]
    });
};
var LeftDescription = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var DescriptionBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var Description = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var LogoItem = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject3());
/* harmony default export */ __webpack_exports__["Z"] = (LeftBox);


/***/ }),

/***/ 13097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_lab_LoadingButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52029);
// import styled from "@emotion/styled";


var SignButton = function(props) {
    var text = props.text, onClick = props.onClick, type = props.type, loading = props.loading, className = props.className, endIcon = props.endIcon, disabled = props.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab_LoadingButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        type: type || "button",
        className: className || "",
        loading: loading,
        onClick: onClick,
        fullWidth: true,
        variant: "contained",
        disabled: disabled,
        sx: {
            background: "var(--primary)",
            height: "45px",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "20px",
            borderRadius: "63px"
        },
        endIcon: endIcon,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignButton);


/***/ }),

/***/ 34489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ Layout; },
/* harmony export */   "Fe": function() { return /* binding */ Terms; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "gJ": function() { return /* binding */ BackGround; },
/* harmony export */   "zV": function() { return /* binding */ EmptySpace; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100vw;\n	min-height: 100%;\n	background-color: #000000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n	min-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1 0 auto;\n	position: relative;\n	min-height: 100%;\n	max-width: 100%;\n	min-width: 60vw;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	background-color: white;\n	overflow-y: auto;\n	overflow-x: hidden;\n\n	@media screen and (max-device-height: 900px) {\n		justify-content: start;\n	}\n\n	.container {\n		margin: 20px auto;\n		width: 90vw;\n		max-width: 500px;\n		border-radius: 30px;\n		box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n			rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		padding: 5%;\n\n		.description1 {\n			font-style: normal;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			text-align: center;\n		}\n\n		.description2 {\n			text-align: center;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			white-space: pre-wrap;\n			word-break: break-all;\n		}\n\n		> .title {\n			font-size: 30px;\n			font-weight: 800;\n			text-align: left;\n			color: #111;\n			text-align: center;\n		}\n\n		> .inputLabel {\n			height: 20px;\n			align-self: stretch;\n			flex-grow: 0;\n			font-family: NanumGothic;\n			font-size: 14px;\n			font-weight: bold;\n			font-stretch: normal;\n			font-style: normal;\n			line-height: 1.43;\n			letter-spacing: 0.4px;\n			text-align: left;\n			color: #000;\n		}\n\n		> .textFiled {\n			height: 48px;\n			line-height: 48px;\n			align-self: stretch;\n			flex-grow: 0;\n			display: flex;\n			flex-direction: row;\n			justify-content: flex-start;\n			align-items: flex-start;\n			gap: 10px;\n			padding: 12px;\n			border-radius: 8px;\n			border: solid 1px #afb1b6;\n			background-color: white;\n			width: 100%;\n			margin-top: 8px;\n			box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n				rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		}\n\n		.link {\n			font-weight: 700;\n			font-size: 12px;\n			line-height: 10px;\n			text-decoration-line: underline;\n			color: #afb1b6;\n		}\n\n		.goJoin {\n			font-weight: 700;\n			font-size: 16px;\n			line-height: 16px;\n			text-align: center;\n\n			/* Black */\n\n			color: #000000;\n			> span {\n				background: var(--primary);\n				text-decoration-line: underline;\n				-webkit-background-clip: text;\n				-webkit-text-fill-color: transparent;\n				background-clip: text;\n				text-fill-color: transparent;\n			}\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 0;\n	line-height: 1.5714285714285714;\n	font-size: 13px;\n	font-weight: 400;\n	text-align: center;\n	color: #212b36;\n	margin-top: 24px;\n\n	> a {\n		margin: 0;\n		color: #212b36;\n		&:hover {\n			color: #0378ef;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: ",
        "px;\n	width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var BackGround = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
var Layout = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject1());
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2());
var Terms = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject3());
var EmptySpace = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), function(props) {
    return props.space;
});


/***/ }),

/***/ 57386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Is": function() { return /* binding */ makePhoneNumber; },
/* harmony export */   "Ks": function() { return /* binding */ makePhoneNumberV2; },
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "df": function() { return /* binding */ validatePhone2; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; }
/* harmony export */ });
function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
function validatePhone(phone, isNotKorea) {
    if (isNotKorea) return true;
    return phone.length === 10 && phone.startsWith("10");
// const patternPhone = new RegExp("1[016789]-[^0][0-9]{2,3}-[0-9]{3,4}");
// if (patternPhone.test(phone)) {
// 	return true;
// }
// return false;
}
function validatePhone2(phone) {
    return phone.startsWith("010");
}
function makePhoneNumber(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    if (result.length === 11 && result.startsWith("010")) return result.slice(1);
    return result;
}
function makePhoneNumberV2(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    return result;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3978,1664,9774,2888,179], function() { return __webpack_exec__(70772); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);